<label
    class="wrapper"
    [ngClass]="{
        'inline': inline,
        'margin-small': marginBottom === 'small',
        'margin-default': marginBottom === 'default'
    }"
>
    <input
        [formControl]="formControl"
        class="input kk-visuallyhidden"
        type="checkbox"
        [name]="control | controlToKeyName"
        [checked]="checked"
        [required]="required"
    />
    <span
        class="element"
        [ngStyle]="{ color: color }"
        [ngClass]="{ 'input-error': formControl.touched && formControl.invalid }"
    >
        <span class="icon"><app-svg-icon iconName="tick"></app-svg-icon></span>
    </span>
    <span class="text display-label">
        <ng-content></ng-content>
    </span>
</label>
